import api from '../api';
import { windowResize } from '../utils';

export const dispatchBetsHistory = (betsHistory) => ({
	type: 'BETS_HISTORY',
	payload: betsHistory
});

export const getBetHistory = () => dispatch => {
	return api.getBetsHistory().then((response) => {
		const betsHistory = response['data'];
		dispatch(dispatchBetsHistory(betsHistory));
		windowResize();
	});
}



// WEBPACK FOOTER //
// ./actions/betsActions.js